import { useState } from "react"
import { ALL_REGIONS } from "../../helpers/dashboards"

export const UseGetAllUserRegions = () => {
  const [allUserRegions, setAllUserRegions] = useState([])

  const getRegionsToDashboards = roles => {
    const rawUserRegions = roles.reduce((prev, current) => {
      const currentRegions = current?.regions
      if (currentRegions) return [...prev, ...currentRegions]
      return prev
    }, [])

    const allRegionsArray = rawUserRegions?.includes("CENTRO_SUR") || roles[0]?.role?.includes("ADMIN")
      ? ALL_REGIONS
      : rawUserRegions
    setAllUserRegions(allRegionsArray)
    return allRegionsArray
  }

  const getRegions = roles => {
    const rawUserRegions = roles.reduce((prev, current) => {
      const currentRegions = current?.regions
      if (currentRegions) return [...prev, ...currentRegions]
      return prev
    }, [])

    const allRegionsArray = rawUserRegions?.includes("CENTRO_SUR") || roles[0]?.role?.includes("ADMIN")
      ? [...ALL_REGIONS, "CENTRO_SUR"]
      : [...rawUserRegions, "CENTRO_SUR"]
    setAllUserRegions(allRegionsArray)
    return allRegionsArray
  }

  return {
    getRegions,
    allUserRegions,
    getRegionsToDashboards
  }
}